import React from "react";
import LatexTableRow from "./LatexTableRow";
import { EditableRowNames } from "../Data/LatexData";
import LatexTotalesRows from "./LatexTotalesRows";
import { useFormContext, useWatch } from "react-hook-form";
import { MonthHeader } from "../../../Utils/TableComponents";

export default function LatexMonth(props) {
    const { month, monthIndex } = props;

    const { control } = useFormContext();

    const isFirstTable = month === 'enero';

    let totalKgSecos = 0;
    let totalValorTotal = 0;

    return (
        <table key={monthIndex} >
            <MonthHeader month={month} monthIndex={monthIndex} />
            <tbody>
                {EditableRowNames.map((rowName, rowIndex) => {
                    const RowData = useWatch({
                        control,
                        name: `ComparativoCostoMP.LatexData.${rowName}`,
                    });
                    if (!RowData) return null;
                    if (!RowData[month]) return null;
                    const kgSecos = RowData[month].KgSecos;
                    const costoKgSec = RowData[month].CostoKgSec;
                    const isNegative = RowData.isNegative;
                    const total = (kgSecos * costoKgSec).toFixed(2);

                    // Lógica según el excel (Sumar siempre en el valor total es lo correcto)
                    if (isNegative) {
                        totalKgSecos -= parseFloat(kgSecos);
                    } else {
                        totalKgSecos += parseFloat(kgSecos);
                    }
                    totalValorTotal += parseFloat(total);

                    return (
                        <LatexTableRow key={rowIndex}
                            isFirstTable={isFirstTable}
                            rowIndex={rowIndex}
                            rowName={rowName}
                            month={month}
                            monthIndex={monthIndex}
                            total={total}
                        />
                    )
                })}
                <LatexTotalesRows key={monthIndex}
                    monthIndex={monthIndex}
                    isFirstTable={isFirstTable}
                    month={month}
                    ctoPromedioDelInvenKgSecos={totalKgSecos}
                    ctoPromedioDelInvenValorTotal={totalValorTotal}
                />
            </tbody>
        </table>
    );
}
